import { html } from '../html.js';
import { DEFAULT_PRINT_OPTIONS } from '../print-options.js';
import { t } from '../strings.js';
import { docDate, field, fields, footer, header, ltr } from './parts.js';
import { notesBlock, party, pricedLineTable, reasonLabel, statusBadge, statusLabel, totalsBlock, yesNo, } from './record-parts.js';
/**
 * PUR-04's purchase return as a printed document — the spec's DEBIT NOTE, the
 * paper the company sends the supplier to say "we are charging you back".
 *
 * It names the BILL it is raised against (BR-PUR-04-06: the bill's own price,
 * so the two documents agree to the cent), the REASON, and the one fact that
 * changes what the supplier should expect at their dock: a VALUE-ONLY return
 * is a price correction with no goods moving, and the paper says so in a
 * stamp rather than in a field a reader could miss.
 */
export function purchaseReturnHtml(data, locale, company, generatedAt, generatedBy, print = DEFAULT_PRINT_OPTIONS) {
    const badge = statusBadge(data.status, locale);
    const valueOnly = data.valueOnly ? html `<span class="doc-badge">${t('valueOnly', locale)}</span>` : null;
    return html `
    ${header(company, t('purchaseReturnTitle', locale), badge ?? valueOnly)}
    ${fields([
        field(t('returnNo', locale), ltr(data.code)),
        field(t('invoiceDate', locale), docDate(data.returnDate)),
        field(t('supplierCode', locale), ltr(data.partnerCode)),
        field(t('status', locale), statusLabel(data.status, locale)),
        field(t('billRef', locale), ltr(data.billCode)),
        field(t('reason', locale), reasonLabel(data.reason, locale)),
        ...(data.valueOnly
            ? [field(t('valueOnly', locale), yesNo(true, locale))]
            : [field(t('restocked', locale), yesNo(data.restocked, locale))]),
    ])}
    ${party(t('supplier', locale), data.partnerName)}
    ${pricedLineTable(data.lines, data.currency, locale, print)}
    ${totalsBlock(data, locale, print)}
    ${notesBlock(t('reasonNote', locale), data.reasonNote)}
    ${notesBlock(t('notes', locale), data.notes)}
    ${footer(locale, generatedAt, company.name, generatedBy)}
  `;
}
//# sourceMappingURL=purchase-return.js.map